<template>
	<div>
		<v-container id="org-profile" fill-height fluid grid-list-xl>
			<div class="pvcam-loading" :style="{backgroundImage: `url(/favicon.png)`}"></div>
			<v-layout v-if="!loading" justify-space-around wrap>
				<v-flex xs12 md3>
					<material-card color="primary" title="Organisation Details">
						<v-form>
							<v-container py-0>
								<v-layout wrap>
									<v-flex md12>
										<v-text-field
											v-model="org.name"
											label="Organisation Name*"
											class="purple-input"
											:rules="required"
											:disabled="disable"
											:readonly="readOnly"
										/>
									</v-flex>
									<v-flex md12>
										<v-text-field
											v-model="org.primaryEmail"
											label="Primary Email*"
											class="purple-input"
											:rules="emailRules"
											:disabled="disable"
											:readonly="readOnly"
										/>
									</v-flex>
									<v-flex md12>
										<v-text-field
											v-model="org.primaryPhone"
											label="Primary Phone*"
											class="purple-input"
											:rules="required"
											:disabled="disable"
											:readonly="readOnly"
										/>
									</v-flex>
									<v-flex md12>
										<v-text-field
											v-model="org.secondaryEmail"
											label="Secondary Email"
											class="purple-input"
											:rules="emailRules"
											:disabled="disable"
											:readonly="readOnly"
										/>
									</v-flex>
									<v-flex md12>
										<v-text-field
											v-model="org.secondaryPhone"
											label="Secondary Phone"
											class="purple-input"
											:disabled="disable"
											:readonly="readOnly"
										/>
									</v-flex>
									<v-flex md12>
										<pvcam-wc-country-selector
											:target="'Profile'"
											:disabled="disable"
											:current-selection="org.countryCode"
											:readonly="readOnly"
										/>
									</v-flex>
									<v-flex xs12 text-xs-right>
										<v-btn
											class="mx-0 font-weight-light"
											color="primary"
											:loading="loader1"
											:disabled="disable || loader1 || readOnly"
											@click="updateProfile"
										>Update Profile</v-btn>
									</v-flex>
								</v-layout>
							</v-container>
						</v-form>
					</material-card>
				</v-flex>
				<v-flex xs12 md4>
					<material-card color="primary" title="Address">
						<v-form>
							<v-container py-0>
								<v-layout wrap>
									<v-flex xs12 md12>
										<v-text-field
											v-model="org.Address[0]['address_l1']"
											label="Address Line 1*"
											class="purple-input"
											:rules="required"
											:disabled="disable"
											:readonly="readOnly"
										/>
									</v-flex>
									<v-flex xs12 md12>
										<v-text-field
											v-model="org.Address[0]['address_l2']"
											label="Address Line 2"
											class="purple-input"
											:disabled="disable"
											:readonly="readOnly"
										/>
									</v-flex>
									<v-flex xs12 md12>
										<v-text-field
											v-model="org.Address[0]['address_l3']"
											label="Address Line 3"
											class="purple-input"
											:disabled="disable"
											:readonly="readOnly"
										/>
									</v-flex>
									<v-flex xs12 md12>
										<v-text-field
											v-model="org.Address[0]['address_l4']"
											label="Address Line 4"
											class="purple-input"
											:disabled="disable"
											:readonly="readOnly"
										/>
									</v-flex>
									<v-flex xs12 md6>
										<v-text-field
											v-model="org.Address[0]['region']"
											label="Region*"
											class="purple-input"
											:rules="required"
											:disabled="disable"
											:readonly="readOnly"
										/>
									</v-flex>
									<v-flex xs12 md6>
										<v-text-field
											v-model="org.Address[0]['subregion']"
											label="Subregion"
											class="purple-input"
											:disabled="disable"
											:readonly="readOnly"
										/>
									</v-flex>
									<v-flex xs12 md6>
										<v-text-field
											v-model="org.Address[0]['code']"
											label="Post Code*"
											class="purple-input"
											:rules="required"
											:disabled="disable"
											:readonly="readOnly"
										/>
									</v-flex>
									<v-flex xs12 md6>
										<pvcam-wc-country-selector
											:target="'Address'"
											:disabled="disable"
											:readonly="readOnly"
											:current-selection="org.Address[0]['country']"
										/>
									</v-flex>
									<v-flex xs12 text-xs-right>
										<v-btn
											class="mx-0 font-weight-light"
											color="primary"
											:loading="loader2"
											:disabled="disable || loader2 || readOnly"
											@click="updateAddress"
										>Update Address</v-btn>
									</v-flex>
								</v-layout>
							</v-container>
						</v-form>
					</material-card>
				</v-flex>
				<v-flex xs12 md3 v-if="$can('disableOrg')">
					<material-card
						:color="status"
						:title="org.disabled === false ? 'Enabled': 'Disabled'"
						text="current status"
					>
						<v-card-text class="text-xs-center">
							<v-dialog v-model="dialog" persistent max-width="600px">
								<template v-slot:activator="{ on }">
									<v-btn color="primary" rounded class="font-weight-light" v-on="on">Enable/Disable</v-btn>
								</template>
						
								<v-card class="confirm-format">
									<v-row  
										align="center"
										justify="center"
										class="padding-top"
									>
										<v-col cols="2" class="d-flex justify-center">
											<v-icon 
												color="red"
												size="50"
											>
												mdi-alert
											</v-icon>
										</v-col>

										<v-col class="d-flex justify-center">
											<h2>Enable/Disable Organisation</h2>
										</v-col>
									</v-row>

									<v-row>
										<v-col cols="12">
											Please enter <strong class="warning--text">{{org.disabled === 'False' ? 'DISABLE' : 'ENABLE'}}</strong> to complete your action
										</v-col>
										<v-col cols="12">
											<v-text-field
												v-model="answer" 
												:rules="answerRules" 
												@keyup.enter="enableOrg"
											/>
										</v-col>
									</v-row>

									<v-row  
										align="center"
										justify="center"
										class="padding-bottom reboot-actions"
									>
										<v-btn
											color="red" 
											text
											@click="dialog = false"
										>
											Cancel
										</v-btn>
										<v-spacer></v-spacer>
										<v-btn 
											color="green"
											text
											:disabled="userConfirmation"
											@click="enableOrg"
										>
											Complete Action
										</v-btn>
										<!-- <v-progress-circular
											v-else
											indeterminate
											color="primary"
										></v-progress-circular> -->
										<br>
									</v-row>
								</v-card>
							</v-dialog>
						</v-card-text>

					</material-card>



            


				</v-flex>
			</v-layout>
		</v-container>
		<div class="speed-dial-container">
			<v-speed-dial
				v-model="orgOptions"
				fixed
				bottom
				right
				direction="top"
				open-on-hover
				transition="slide-y-reverse-transition"
			>
				<template v-slot:activator>
					<v-btn v-model="orgOptions" color="grey" dark fab x-large>
						<v-icon v-if="orgOptions">mdi-close</v-icon>
						<v-icon v-else>mdi-domain</v-icon>
					</v-btn>
				</template>

				<v-btn v-if="$can('listUsers')" fab dark large color="secondary" @click="toOrg('users')">
					<v-tooltip left>
						<template v-slot:activator="{ on }">
							<v-icon v-on="on">mdi-account-group</v-icon>
						</template>
						<span>User List</span>
					</v-tooltip>
				</v-btn>
				<v-btn v-if="$can('viewVehicle')" fab dark large color="primary" @click="toOrg('vehicles')">
					<v-tooltip left>
						<template v-slot:activator="{ on }">
							<v-icon v-on="on">mdi-car-multiple</v-icon>
						</template>
						<span>Vehicle List</span>
					</v-tooltip>
				</v-btn>
				<v-btn v-if="$can('listGroups')" fab dark large color="info" @click="toOrg('manage')">
					<v-tooltip left>
						<template v-slot:activator="{ on }">
							<v-icon v-on="on">mdi-file-tree</v-icon>
						</template>
						<span>Manage</span>
					</v-tooltip>
				</v-btn>
			</v-speed-dial>
		</div>
	</div>
</template>

<script>

	import { AmplifyEventBus } from "aws-amplify-vue";
	import {
		GetOrg,
		UpdateOrg,
		CreateOrgAddress,
		UpdateOrgAddress,
		UpdateOrgStatus
	} from "@/services/API.js";

	import { Logger } from "aws-amplify";
	const logger = new Logger("OrgProfile");

	export default {
		data: () => ({
			orgOptions: false,
			loading: true,
			loader1: false,
			loader2: false,
			dialog: false,
			disable: false,
			status: false,
			color: "",
			text: "",
			org: {
				Address: [
					{
						id: "",
						address_l1: "",
						address_l2: "",
						address_l3: "",
						address_l4: "",
						subregion: "",
						region: "",
						code: "",
						country: ""
					}
				]
			},
			countryCode: '',
			answer: "",
			emailRules: [
				v =>
					/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
					"E-mail must be valid"
			],
			required: [v => !!v || "required"]
		}),
		computed: {
			answerRules() {
				const rules = [];
				const answer = this.org.disabled === "False" ? "disable" : "enable";
				if (this.org) {
					const rule = v =>
						v.toLowerCase() === answer || "Answer does not match";
					rules.push(rule);
				}
				return rules;
			},
			readOnly () {
				return !this.$can('updateOrg')
			},
			currentCountry() {
				return this.org.Address[0].country.length > 0 ? this.org.Address[0].country : '';
			},
			userConfirmation() {
				let status = JSON.parse(this.org.disabled);
				
				if(!status) {
					return	this.answer.toLowerCase() == 'disable' ? false : true;
				}
				else {
					return this.answer.toLowerCase() == 'enable' ? false : true;
				}
			}
		},
		watch: {
			dialog() {
				// clear text input on open/close
				this.answer = '';
			}
		},
		async beforeMount() {
			if (this.$route.params.name) {
				const id = this.$route.params.name;
				let org = await GetOrg(id);
				org.id = id;
				logger.debug("set org to", org)
				if (org && org.Address.length > 0) {
					this.org = org;
					
				} else {
					this.emptyAddress = true;
					this.org = {
						...org,
						Address: [
							{
								id: "",
								address_l1: "",
								address_l2: "",
								address_l3: "",
								address_l4: "",
								subregion: "",
								region: "",
								code: "",
								country: ""
							}
						]
					};
				}
				this.status = this.checkStatus();
				this.loading = false;
			} else {
				//error
			}
		},
		mounted() {
			window.EventBus.$on("updateOrgAddress", this.handleUpdateCountry);
			window.EventBus.$on("updateOrgProfile", this.handleUpdateCountryCode);
		},
		methods: {
			checkStatus() {
				if (this.org.disabled === false) {
					return "success";
				} else {
					this.disable = true;
					return "error";
				}
			},
			async updateProfile() {
				this.loader1 = true;
				const {
					primaryPhone,
					primaryEmail,
					secondaryPhone,
					secondaryEmail,
					countryCode,
					name
				} = this.org;
				const res = await UpdateOrg(this.org.id, {
					primaryPhone,
					primaryEmail,
					secondaryPhone,
					secondaryEmail,
					countryCode,
					name
				});
				logger.info(res);
				this.loader1 = false;
				if (res) {
					AmplifyEventBus.$emit("snackEvent", {
						color: "success",
						text: `organisation ${this.org.name} profile has updated`
					});
				}
			},
			async updateAddress() {
				this.loader2 = true;
				let res;
				const {
					id,
					address_l1,
					address_l2,
					address_l3,
					address_l4,
					subregion,
					region,
					code,
					country
				} = this.org.Address[0];
				if (!this.emptyAddress) {
					res = await UpdateOrgAddress(this.org.id, id, {
						address_l1,
						address_l2,
						address_l3,
						address_l4,
						subregion,
						region,
						code,
						country
					});
					logger.info("UpdateOrgAddress", res);
				} else {
					res = await CreateOrgAddress(this.org.id, {
						address_l1,
						address_l2,
						address_l3,
						address_l4,
						subregion,
						region,
						code,
						country
					});
					logger.info("CreateOrgAddress", res);
					this.org.Address[0].id = res.id;
				}
				this.loader2 = false;
				if (res) {
					AmplifyEventBus.$emit("snackEvent", {
						color: "success",
						text: `organisation ${this.org.name} address has updated`
					});
				}
			},
			async enableOrg() {
				this.dialog = false;
				const enabled = this.org.disabled === false ? false : true;
				const res = await UpdateOrgStatus(this.org.id, enabled);
				if (res) {
					if (res.enabled === "True") {
						this.org.disabled = false;
						this.disable = false;
						this.status = "success";
						AmplifyEventBus.$emit("snackEvent", {
							color: "success",
							text: `organisation ${this.org.name} has enabled`
						});
					} else {
						this.org.disabled = true;
						this.disable = true;
						this.status = "error";

						AmplifyEventBus.$emit("snackEvent", {
							color: "success",
							text: `organisation ${this.org.name} has disabled`
						});
					}
				}
			},
			toOrg(link) {
				this.$router.push({
					path: `/organisation/${this.$route.params.name}/${link}`
				});
			},
			handleUpdateCountry(val) {
				this.org.Address[0]['country'] = val;
			},
			handleUpdateCountryCode(val) {
				this.org.countryCode = val;
			}
		}
	};
</script>

<style lang="scss" scoped>
	#org-profile {
		.v-input--switch {
			justify-content: center;
		}
	}
	.speed-dial-container {
		// position: fixed;
		// bottom: 14vh;
		// right: 3vw;
		// z-index: 4;

		.v-speed-dial__list {
			button {
				margin-bottom: 5px;
			}
		}
	}

	.confirm-format {
    padding: 1.5em;
  }
</style>
